/* eslint-disable indent */
import { initTabIndicator, initTabList } from "../../ui/tabs/index.js";
import { openAppointmentPopup } from "./popup.js";
import { generateReview } from "./review.js";

const main = document.querySelector("main");

function closeAllDoctorPopups() {
    const popups = document.querySelectorAll(".popup--doctor");

    popups.forEach((popup) => {
        popup.classList.remove("open");
    });
}

export function closeDoctorPopup(doctorId) {
    const popup = document.getElementById(`popup--doctor-${doctorId}`);

    if (popup) {
        popup.classList.remove("open");
    }
}

export async function openDoctorPopup(doctorId) {
    closeAllDoctorPopups();

    const popup = document.getElementById(`popup--doctor-${doctorId}`);

    if (popup) {
        popup.classList.add("open");
    }
}

function generateDoctorPopupHTML({
    doctor, city, address, serviceType, reviews, appointment = true,
}) {
    if (!main) return null;

    const imageSrc = doctor?.avatar_big;

    let addressStr = address;

    if (typeof address === "object") {
        addressStr = `
            ${Object.values(address).map((addr) => `
                <div class="card__content-info">
                    <i class="icon icon-pin" aria-label="icon pin"></i>
                    <div>
                        <p class="p">${addr.replace(/^г\.\s*[^,]+,\s*/, "")}</p>
                    </div>
                </div>
                `).join("")}
        `;
    } else {
        addressStr = address ? `
            <div class="card__content-info">
                <i class="icon icon-pin" aria-label="icon pin"></i>
                <div>
                    <p class="p">${address.replace(/^г\.\s*[^,]+,\s*/, "")}</p>
                </div>
            </div>
        ` : "";
    }

    if (city === "online") {
        addressStr = "Онлайн-консультации";
    }

    const popupEl = document.createElement("div");

    popupEl.classList.add("popup", "popup--doctor");

    popupEl.id = `popup--doctor-${doctor.id}`;

    const descriptionEl = document.createElement("p");

    descriptionEl.innerHTML = doctor.description ? doctor.description : "";

    const description = descriptionEl.innerText;

    popupEl.innerHTML = `
            <div class="popup__wrapper doctor">
                <button class="button button--ghost--dark popup__close" type="button">
                    <i class="icon icon-close"></i>
                </button>
                <div class="popup__head">
                    <h3 class="h3">${doctor.name}</h3>
                </div>
                <div class="popup__content scrollbar">
                    <div class="tabs">
                        <div class="tabs__tab-list-wrapper">
                            <ul class="tabs__tab-list">
                                <li 
                                    data-value="0" 
                                    class="tabs__tab-list-item--selected"
                                    ${!reviews ? 'style="width:100%"' : ""}
                                >
                                    <button class="tabs__tab-button" type="button">Информация</button>
                                </li>
                                ${reviews ? `
                                        <li data-value="1" class="tabs__tab-list-item">
                                            <button class="tabs__tab-button" type="button">Отзывы</button>
                                        </li>
                                    ` : ""
        }
                            </ul>
                            <i class="tabs__indicator"></i>
                        </div>
                        <ul class="tabs__tab-panel-list">
                            <li data-value="0" class="tabs__tab-panel-item doctor__card card card--entity">
                                <div class="doctor__photo card__image">
                                    <img src="${imageSrc}" alt="${doctor.name}">
                                </div>
                                <div class="doctor__info card__content">
                                    <p class="card__content-info p">
                                    ${doctor.specialization ? doctor.specialization : ""}</p>
                                    ${addressStr}
                                    
                                    <div class="card__content-text">
                                        <p class="p description">${description}</p>
                                    </div>
                                        
                                </div>
                            </li>
                            <li data-value="1" class="tabs__tab-panel-item doctor__reviews">
                                <div class="reviews__list">
                                    <!-- отзывы -->
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="popup__bottom">
                    ${appointment ? `
                            <button class="button button--primary--light button-open-popup button-open-popup--appointment-doctor"
                            type="button" >
                                Записаться
                            </button>
                        ` : ""
        }
                </div>
            </div>
    `;

    const closeButton = popupEl.querySelector(".popup__close");

    closeButton.addEventListener("click", () => closeDoctorPopup(doctor.id));

    if (reviews) {
        const reviewList = popupEl.querySelector(".reviews__list");

        Object.values(reviews).forEach((review) => {
            if (review.master_id === doctor.id) {
                const reviewEl = generateReview(review);

                reviewList.append(reviewEl);
            }
        });
    }

    const tabs = popupEl.querySelector(".tabs");

    initTabList(tabs);
    window.addEventListener("resize", () => initTabIndicator(tabs));

    if (appointment) {
        const appointmentButton = popupEl.querySelector(".button-open-popup--appointment-doctor");

        // sessionStorage.removeItem("doctor-appointment");

        appointmentButton.addEventListener("click", () => {
            closeAllDoctorPopups();
            openAppointmentPopup(serviceType);

            sessionStorage.setItem("doctor-appointment", JSON.stringify({
                serviceType,
                doctor,
            }));
        });
    }

    return popupEl;
}

export function generateDoctorCardHTML({
    doctor, city, address, serviceType, reviews, appointment = true, metro=[]
}) {
    const imageSrc = doctor?.avatar_big;

    let addressStr = address;

    if (typeof address === "object") {
        addressStr = `
            ${Object.values(address).map((addr) => `
                <div class="card__content-info">
                    <i class="icon icon-pin" aria-label="icon pin"></i>
                    <div>
                        <p class="p">${addr.replace(/^г\.\s*[^,]+,\s*/, "")}</p>
                    </div>
                </div>
                `).join("")}
        `;
    } else {
        addressStr = address ? `
            <div class="card__content-info">
                <i class="icon icon-pin" aria-label="icon pin"></i>
                <div>
                    <p class="p">${address.replace(/^г\.\s*[^,]+,\s*/, "")}</p>
                </div>
            </div>
        ` : "";
    }

    if (city === "online") {
        addressStr = "Онлайн-консультации";
    }
    const card = document.createElement("div");

    card.id = `card--doctor-${doctor.id}`;

    const descriptionEl = document.createElement("p");

    descriptionEl.innerHTML = doctor.description ? doctor.description : "";

    const description = descriptionEl.innerText;

    card.classList.add("card", "card--bordered", "card--entity", "card--center", "swiper-slide", "slider-slide", "js-slider-doctors-slide", "doctor-card");
    card.innerHTML = `
            <picture class="card__image">
                <img src="${imageSrc}" alt="${doctor.name}">
            </picture>
            <div class="card__content">
                
                <div class="card__content-info">
                    <h4 class="h4">${doctor.name}</h4>
                </div>
                
                
                <div class="card__content-info" ${!description ? 'style="display:none"' : ""}>
                    <p class="p p--ellipse description">${description || ""}</p>
                </div>
                   
                
                ${addressStr}

                ${
                    metro ? metro.map((metroStation) => (`
                    <div class="card__content-info">
                        <i class="icon icon-metro" aria-label="icon pin"></i>
                        <p class="p">
                            ${metroStation}
                        </p>
                    </div>
                    `)).join(" ") : ""
                }

                <div class="card__content-buttons">
                    ${appointment ? `
                            <button class="button button--primary--light button-open-popup button-open-popup--appointment-doctor" type="button">
                                Записаться
                            </button>
                        ` : ""
        }
                    <button class="button button--secondary--light button-open-popup button-open-popup--doctor" type="button" data-id="PopupDoctor">
                        Информация о специалисте
                    </button>
                </div>
            </div>
    `;

    const popupEl = generateDoctorPopupHTML({
        doctor,
        city,
        address,
        serviceType,
        reviews,
        appointment,
    });

    if (popupEl) {
        main.append(popupEl);

        const openDoctorInfoButton = card.querySelector(".button-open-popup--doctor");

        openDoctorInfoButton.addEventListener("click", () => openDoctorPopup(doctor.id));
    }

    if (appointment) {
        const appointmentButton = card.querySelector(".button-open-popup--appointment-doctor");

        appointmentButton.addEventListener("click", () => {
            openAppointmentPopup(serviceType);
            sessionStorage.setItem("doctor-appointment", JSON.stringify({
                serviceType,
                doctor,
            }));
        });
    }

    return card;
}

export function generateDoctorLoaderCardHTML(id) {
    const card = document.createElement("div");

    card.dataset.id = id;

    card.classList.add("card", "card--bordered", "card--entity", "card--center", "swiper-slide", "slider-slide", "js-slider-doctors-slide");
    card.innerHTML = `
            <div style="height: 657px;display:flex; align-items:center;justify-content:center" class="card__content">
                <i style="width:24px;height:24px" class="loader"></i>
            </div>
    `;

    return card;
}
